import queryString, { ParsedQuery } from 'query-string';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { LanguageService } from 'services/language-service';
import { LANGUAGES } from 'shared/constants/languages';
import { REDIRECT_SEARCH_PARAM_KEY, ROUTE_LINKS } from 'shared/constants/route-links';
import { DELAY_IN_MILLISECONDS_BEFORE_SCROLLING_TO_BOTTOM } from 'shared/constants/smart-assistant';

export let globalNavigate: NavigateFunction;

export const Navigator = () => {
  globalNavigate = useNavigate();

  return null;
};

export const navigatePostLogin = (queryParams?: ParsedQuery<string>) => {
  let path = ROUTE_LINKS.postLoginRouter;
  if (queryParams) path += `?${queryString.stringify(queryParams)}`;
  globalNavigate(path);
};

export const extractRedirectPathFromQueryParams = (queryParams: ParsedQuery<string>) => {
  const redirect = queryParams[REDIRECT_SEARCH_PARAM_KEY];
  if (typeof redirect === 'string' && redirect.trim() !== '') {
    const decodedRedirect = decodeURIComponent(redirect);
    // If the redirect is a relative path, we return it as is
    if (decodedRedirect.startsWith('/')) return decodedRedirect;

    try {
      return new URL(decodedRedirect).pathname;
    } catch {
      return undefined;
    }
  }

  return undefined;
};

export const buildBillingPortalReturnUrl = (redirectPath?: string): URL => {
  const returnUrl = new URL(`${window.location.origin}${ROUTE_LINKS.postBillingSessionHandler}`);
  returnUrl.searchParams.set(REDIRECT_SEARCH_PARAM_KEY, redirectPath || ROUTE_LINKS.billing);
  return returnUrl;
};

export const navigateToLandingPage = (newTab = false) => {
  const lang = LanguageService.getCurrentLanguage();
  newTab
    ? window.open(`https://www.droxy.ai${lang == LANGUAGES.french ? '/fr' : ''}`, '_blank')
    : (window.location.href = `https://www.droxy.ai${lang == LANGUAGES.french ? '/fr' : ''}`);
};

export const navigateToPricingPage = (newTab = false) => {
  const lang = LanguageService.getCurrentLanguage();
  newTab
    ? window.open(`https://www.droxy.ai${lang == LANGUAGES.french ? '/fr' : ''}/pricing`, '_blank')
    : (window.location.href = `https://www.droxy.ai${lang == LANGUAGES.french ? '/fr' : ''}/pricing`);
};

export const openPopup = (url: string, name?: string) => {
  const popUpWidth = 500;
  const popUpHeight = 600;
  const popUpLeftPosition = window.innerWidth / 2 - popUpWidth / 2 + window.screenX;
  const popUpTopPostition = window.innerHeight / 2 - popUpHeight / 2 + window.screenY;
  return window.open(
    url,
    name ?? 'Popup',
    `popup=true, width=${popUpWidth}, height=${popUpHeight}, top=${popUpTopPostition}, left=${popUpLeftPosition}`
  );
};

export const scrollToSection = (sectionId: string, scrollAreaRef?: React.RefObject<HTMLDivElement>) => {
  const sectionElement = document.getElementById(sectionId);
  if (!sectionElement) return;

  if (scrollAreaRef?.current) {
    const scrollArea = scrollAreaRef.current;
    scrollArea.scrollTo({
      top: sectionElement.offsetTop - scrollArea.offsetTop,
      behavior: 'smooth'
    });
  } else {
    sectionElement.scrollIntoView({ behavior: 'smooth' });
  }
};

export const scrollToBottom = (scrollAreaRef: React.RefObject<HTMLDivElement>) => {
  setTimeout(() => {
    if (!scrollAreaRef.current) return;

    scrollAreaRef.current.scrollTo({ top: scrollAreaRef.current.scrollHeight, behavior: 'smooth' });
  }, DELAY_IN_MILLISECONDS_BEFORE_SCROLLING_TO_BOTTOM);
};
